<template>
  <div class="page-pay-notify-general">
    <div v-if="!isMiniWebView"
         class="page-pay-notify-general-page-header"
    >
      <div class="back">
        <ym-icon class="icon-back"
                 name="back"
                 @click="handleClickBack"
        />
      </div>
    </div>
    <div class="page-pay-notify-general-header">
      <h1 v-if="pageData.title"
          class="title"
      >
        <span>{{ pageData.title }}</span>
        <ym-icon class="icon"
                 name="round-tick"
        />
      </h1>
      <div class="info"
           @click="handleCourseDetail"
      >
        <div class="desc">{{ pageData.desc }}</div>
        <div class="sub-title">{{ pageData.subTitle }}</div>
        <div v-if="pageData.qrCode == null && pageData.joinedProductLink != null"
             class="course-detail-btn"
        >
          查看详情
        </div>
      </div>
    </div>
    <div v-if="pageData.qrCode"
       class="page-pay-notify-general-wechat-group"
    >
      <div class="page-pay-notify-general-wechat-group-header">
        课程学习群
      </div>
      <div v-if="pageData.keyword && pageData.keyword !== ''"
           class="page-pay-notify-general-wechat-group-keyword"
      >
        <span class="text" id="groupKeyword">{{ pageData.keyword }}</span>
        <span class="action copy-btn"
              data-clipboard-action="copy"
              data-clipboard-target="#groupKeyword"
              @click="handleCopy"
        >
          复制
        </span>
      </div>
      <div class="page-pay-notify-general-wechat-group-qr-code-block">
        <div class="tips">
          <template v-if="pageData.keyword !== ''">
            复制后扫码，<span>回复</span>关键字即可进群
          </template>
          <template v-else>
            立即扫码进群
          </template>
        </div>
        <template v-if="inAppWebView && pageData.qrCode && pageData.qrCode.src !== ''">
          <div class="app-scan-action-block copy-btn"
               data-clipboard-action="copy"
               data-clipboard-target="#groupKeyword"
               @click="handleAppScanQrCode"
          >
            <div class="btn">{{ pageData.keyword !== '' ? '已复制，' : '' }}去扫码进群</div>
            <div class="hint">为避免遗漏课程信息，请务必在开课前加入</div>
          </div>
        </template>
        <template v-if="!inAppWebView && pageData.qrCode && pageData.qrCode.src !== ''">
          <div class="qr-code">
            <img :src="pageData.qrCode.src"
                 alt=""
            />
          </div>
          <div class="qr-code-hint"
               v-html="pageData.qrCode.hint"
          ></div>
        </template>

      </div>
    </div>
    <div v-if="!showMobile"
         class="page-pay-notify-general-contact-us"
    >
      {{ pageData.qrCode ? '如无法添加': '如有问题' }}，可拨打
      <a class="link" :href="consumerHotLineHref">{{ consumerHotLine }}</a>
      联系我们
    </div>
  </div>
</template>

<script>
  import ClipboardJS from 'clipboard';
  import {
    getProductPath,
    isAppWebView,
    isMiniWebView,
    projectJump,
  } from '@/utils';
  import { CONSUMER_HOTLINE } from '@/utils/constant';
  import { locationToAppWithRoute } from '@/utils/app-route';

  export default {
    name: 'PayNotifyGeneral',
    props: {
      pageData: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        isMiniWebView: isMiniWebView(),
      };
    },
    computed: {
      pageRouter() {
        const { joinedProductLink } = this.pageData;
        if (joinedProductLink == null) return '';
        return this.fetchProductRoute(joinedProductLink.type, joinedProductLink.id);
      },
      showMobile() {
        return (['course', 'courseCombo', 'project'].includes(this.pageData.product.type));
      },
      consumerHotLine() {
        return CONSUMER_HOTLINE;
      },
      consumerHotLineHref() {
        return `tel:${CONSUMER_HOTLINE}`;
      },
      inAppWebView() {
        return isAppWebView();
      },
    },
    methods: {
      handleCopy() {
        const clipboard = new ClipboardJS('.copy-btn');
        clipboard.on('success', (e) => {
          this.$toast('内容已复制到剪切板');
          e.clearSelection();
        });
        clipboard.on('error', () => {
          this.$toast('复制失败，请手动复制');
        });
      },
      handleClickBack() {
        const { meta } = this.$route || {};
        const { back } = meta;
        if (back) {
          this.$router.replace(back);
          return;
        }
        this.$router.go(-1);
      },
      fetchProductRoute(type, id) {
        if (id === 0) {
          switch (type) {
            case 'audio':
              return { name: 'MyAudio' };
            case 'audioCombo':
              return { name: 'MyAudio' };
            case 'course':
              return { name: 'MyCourse' };
            case 'courseCombo':
              return { name: 'MyCourse' };
            case 'project':
              return { name: 'MyProject' };
            case 'vip':
              return { name: 'MyVipCenter' };
            default:
              return { name: 'Learning' };
          }
        } else if (type === 'learn') {
          return { name: 'MyPlanDetail', params: { id } };
        } else {
          return getProductPath(type, id);
        }
      },

      handleCourseDetail() {
        projectJump(this.pageRouter);
      },
      handleAppScanQrCode() {
        if (this.pageData.keyword === '') {
          const { src, hint } = this.pageData.qrCode;
          locationToAppWithRoute({ name: 'AppQrCodeDetail', params: { qrCode: src, hint } });
          return;
        }
        const clipboard = new ClipboardJS('.copy-btn');
        clipboard.on('success', (e) => {
          const { src, hint } = this.pageData.qrCode;
          locationToAppWithRoute({ name: 'AppQrCodeDetail', params: { qrCode: src, hint } });
          e.clearSelection();
        });
        clipboard.on('error', () => {
          this.$toast('复制失败，请手动复制');
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-pay-notify-general {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: @background-color-base;

    &-page-header {
      width: 100%;
      height: 300px;
      background: @color-primary;

      .back {
        width: 70px;
        height: 70px;
        margin: @size-base 0 0 @size-base;
      }

      .icon-back {
        margin-top: @size-base;
        color: @color-white;
      }
    }

    &-header {
      box-sizing: border-box;
      width: 690px;
      margin-top: -156px;
      margin-bottom: @size-small;
      padding: 0 @size-base;
      background: @color-white;
      border-radius: 12px;

      .title {
        margin: 0;
        padding: @size-extra-medium 0;
        color: @color-text-base;
        font-size: @font-size-extra-extra-large;
        font-weight: @font-weight-bold;
        line-height: 1;
        display: flex;
        align-items: center;

        .icon {
          margin-left: @size-small;
          color: @color-primary;
          font-size: @font-size-largest;
        }
      }
      .info {
        box-sizing: border-box;
        width: 100%;
        padding: @size-base 0 @size-extra-medium 0;
        border-top: 1px solid #eee;

        .desc {
          margin-bottom: @size-small;
          color: @color-text-base;
          font-size: @font-size-medium;
          line-height: 1;
        }
        .sub-title {
          color: @color-text-base;
          font-size: @font-size-large;
          font-weight: @font-weight-bold;
          line-height: 1;
        }
        .course-detail-btn {
          margin-top: @size-extra-medium;
          width: 630px;
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: @color-primary-aide;
          font-size: @font-size-medium;
          font-weight: @font-weight-bold;
          border: 1px solid @color-primary-aide;
          border-radius: 50px;
        }
      }
    }

    &-wechat-group {
      box-sizing: border-box;
      width: 690px;
      padding: 0 @size-base;
      background: @color-white;
      border-radius: 12px;
    }

    &-wechat-group-header {
      position: relative;
      box-sizing: border-box;
      padding: @size-base 0 @size-base @size-small;
      color: @color-text-base;
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;
      border-bottom: 1px solid #eee;

      &:before {
        position: absolute;
        left: 0;
        top: 34px;
        width: 10px;
        height: 36px;
        content: '';
        background: @color-primary;
        border-radius: 2px;
      }
    }
    &-wechat-group-keyword {
      margin: @size-large auto 0;
      display: flex;
      align-items: center;
      justify-content: center;

      .text {
        box-sizing: border-box;
        height: 70px;
        padding: 0 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-text-base;
        font-size: @font-size-medium;
        font-weight: @font-weight-bold;
        line-height: 1;
        border: 1px solid #ccc;
        border-right: none;
        border-radius: 8px;
      }
      .action {
        margin-left: -22px;
        width: 150px;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-white;
        font-size: @font-size-medium;
        line-height: 1;
        background: @color-primary;
        border-radius: 8px;
      }
    }
    &-wechat-group-qr-code-block {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: @size-large;
      margin-bottom: 80px;
      .tips {
        margin-bottom: @size-base;
        color: @color-text-base;
        font-size: @font-size-medium;
        line-height: 1;
        span {
          color: @color-primary-aide;
        }
      }
      .qr-code {
        box-sizing: border-box;
        width: 200px;
        height: 200px;
        margin-bottom: @size-base;
        padding: @size-extra-small;
        background: #e9f7f7;
        border-radius: 8px;

        img {
          display: block;
          width: 180px;
          height: 180px;
        }
      }
      .qr-code-hint {
        box-sizing: border-box;
        padding: 16px @size-base;
        display: flex;
        align-items: center;
        color: @color-white;
        font-size: @font-size-base;
        line-height: 1.2;
        background: @color-highlight;
        border-radius: 25px;
      }
      .app-scan-action-block {
        margin-top: @size-extra-medium;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .btn {
          margin-bottom: @size-small;
          width: 360px;
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: @color-white;
          font-size: @font-size-medium;
          line-height: 1;
          background: @color-primary;
          border-radius: 50px;
        }
        .hint {
          color: @color-highlight;
          font-size: @font-size-base;
          line-height: 1;
        }
      }
    }
    &-contact-us {
      margin-top: @size-small;
      color: @color-text-light;
      font-size: @font-size-small;

      .link {
        color: #576b95;
      }
    }
  }
</style>
